import React, { Dispatch, SetStateAction, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';

import { useHttpUtils } from '../../../Utilities/useHttpUtils';
import LotCountContext from '../../../Contexts/LotCountContext';
import { LotDetailContext } from '../../../Contexts/LotDetailContext';
import useAlert from '../../../Alerts/useAlert';
import usePrivileges from '../../../Auth/usePrivileges';

import CommentDialog from "../../../Dialogs/CommentDialog";

interface UndoGradedButtonProps {
    setLoading: Dispatch<SetStateAction<boolean>>
}

function UndoGradedButton({ setLoading }: UndoGradedButtonProps) {

    const { t } = useTranslation();
    const { setAlert } = useAlert();
    const { fetchDataAuthenticated } = useHttpUtils();
    const lotCountContext = useContext(LotCountContext);

    const { lotDetail: {
        summary: {
            lotNumber,
            businessUnitCode,
            currentStatus,
            isLocked
        }
    }, getLotDetail } = useContext(LotDetailContext);
    const { supervisor, admin } = usePrivileges(businessUnitCode);

    const [showUndoGradedCommentDialog, setShowUndoGradedCommentDialog] = useState<boolean>(false);

    const handleUndoGradedCommentSave = async (comment: string) => {
        setLoading(true);
        await fetchDataAuthenticated(`/api/v1/lot/${lotNumber}/status/undoGraded`, 'PUT', JSON.stringify(comment))
            .then(async response => {
                if (response.ok) {
                    setAlert("success", "Success", "Graded status on the lot has been undone");
                    getLotDetail();
                    lotCountContext.updateCounters();
                } else {
                    let errorMessage = await response.text();
                    throw new Error("Failed to undo the graded status on lot: " + errorMessage);
                }
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <>
            <Button variant="primary"
                onClick={() => setShowUndoGradedCommentDialog(true)}
                disabled={isLocked || (!supervisor && !admin)}
                hidden={currentStatus !== "Graded"}>
                {t('LotDetails.Summary.UndoGraded')}
            </Button>
            <CommentDialog
                showDialog={showUndoGradedCommentDialog}
                closeDialog={() => setShowUndoGradedCommentDialog(false)}
                onSave={handleUndoGradedCommentSave} />
        </>
    );
}

export default UndoGradedButton;